import { Box } from "@chakra-ui/react";
import { BaseButton, BaseStack, baseColors } from "goi_common/src/design-system";

interface MubinsoFixedCTAProps {
  primary: { label: string; disabled?: boolean; onClick: () => void };
  /** 고른 게 없을 때만 준다. 골랐으면 건너뛸 이유가 없다 */
  secondary?: { label: string; disabled?: boolean; onClick: () => void };
}

/**
 * 무빈소 장례식장 선택 화면의 하단 고정 버튼.
 *
 * 목록 아래 인라인으로 두면 시군구에 장례식장이 20곳인 곳(창원, 전주, 목포)에서 더 보기를
 * 펼쳤을 때 버튼이 화면 밖으로 밀린다. 이 화면의 이탈은 "건너뛰기를 눌러서" 가 아니라
 * "무엇을 눌러야 할지 몰라 아무것도 안 누르고 나가는" 쪽이라, 누를 것이 항상 보여야 한다.
 *
 * 같은 화면 2단계의 `ConsultingCallCTA` 와 같은 구조다(fixed, maxWidth 480px, 상단 흰 그라데이션).
 * 두 단계에서 버튼이 다른 자리에 뜨면 같은 화면으로 안 읽힌다. 두 바가 동시에 뜨는 일은
 * 없다. 1단계와 2단계는 `isDone` 으로 갈린 다른 return 이다.
 */
export const MubinsoFixedCTA = ({ primary, secondary }: MubinsoFixedCTAProps) => (
  <BaseStack
    position="fixed"
    bottom={0}
    /*
     * left, right 를 주지 않으면 fixed 요소가 "원래 있었을 자리" 를 기준으로 잡는다.
     * 이 바는 px="20px" 인 본문 안에 있어서 20px 오른쪽에서 시작하고, 거기서 480px 을
     * 그어 화면 밖으로 넘쳤다. 0 으로 못박고 margin auto 로 뷰포트 가운데에 세운다.
     */
    left={0}
    right={0}
    width="auto"
    maxWidth="480px"
    mx="auto"
    spacing={0}
    zIndex={100}
    // 그라데이션이 목록 위 40px 을 덮는다. 그대로 두면 마지막 카드의 체크박스가 안 눌린다
    pointerEvents="none"
  >
    {/* 목록이 버튼 뒤로 잘려 보이지 않게 흰색으로 흘려보낸다 */}
    <Box
      width="100%"
      height="40px"
      css={{
        background:
          "linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.16) 24%, rgba(255, 255, 255, 0.75) 70%, rgb(255, 255, 255) 100%)",
      }}
    />

    <BaseStack
      width="100%"
      backgroundColor={baseColors.white}
      padding="0 20px 20px"
      spacing={0}
      pointerEvents="auto"
    >
      <BaseButton type="primary" size="large" disabled={primary.disabled} onClick={primary.onClick}>
        <Box className="headline_3_sb" fontWeight={700}>
          {primary.label}
        </Box>
      </BaseButton>

      {secondary && (
        <>
          <Box height="10px" flexShrink={0} />
          <BaseButton
            type="assistive_1"
            size="large"
            outlined
            disabled={secondary.disabled}
            onClick={secondary.onClick}
          >
            <Box className="body_2_normal_sb" fontWeight={700}>
              {secondary.label}
            </Box>
          </BaseButton>
        </>
      )}
    </BaseStack>
  </BaseStack>
);
